import React, { useContext, useMemo } from 'react';
import PropTypes from 'prop-types';
import { ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleNotch } from '@fortawesome/free-solid-svg-icons';

import { ACTIVE } from '../../Constants/AssetAssociations';
import OrgsMapContext from '../../Context/OrgsMapContext';
import Modal from '../ModalLayout';

export default function DeleteAssetModalDisplay(props) {
  const {
    deleteRequestPending,
    isOpen,
    toggleModal,
    handleDeleteAsset,
    assetToDelete = {},
    error,
  } = props;

  const orgsMap = useContext(OrgsMapContext);
  const orgBillingEnabled = useMemo(
    () => orgsMap?.[assetToDelete?.orgID]?.features?.billing?.enabled,
    [assetToDelete?.orgID, orgsMap]
  );
  const assetHasActiveSubscription = useMemo(
    () => assetToDelete?.assetAssociation?.subscription_status === ACTIVE,
    [assetToDelete?.assetAssociation?.subscription_status]
  );

  return (
    <Modal
      desktopHeight="auto"
      isOpen={isOpen}
      toggleModal={() => toggleModal()}
    >
      <ModalHeader className="border-0" toggle={() => toggleModal()}>
        Delete Asset
      </ModalHeader>
      <ModalBody className="container-fluid">
        {(() => {
          switch (true) {
            case orgBillingEnabled && assetHasActiveSubscription:
              return (
                <>
                  <div className="row justify-content-center">
                    <div className="col-12 col-md-10 text-left">
                      <p className="text-muted">
                        <span className="font-weight-medium text-text-dark">
                          {assetToDelete.nickname || 'This asset'}{' '}
                        </span>
                        has an active subscription. Deleting this asset will
                        permanently remove it from your company&apos;s
                        inventory, and all data associated with it will be lost.
                        Cancellation fees may apply to deleting an asset with an
                        active subscription.
                      </p>
                    </div>
                  </div>
                  <div className="row justify-content-center">
                    <div className="col-12 col-md-10 text-left">
                      <p className="text-muted">
                        If you&#39;d like to get the data from the asset first;
                        close this dialogue, go to the asset dashboard and
                        download the data from each smart tile as CSVs.
                      </p>
                    </div>
                  </div>
                </>
              );
            default:
              return (
                <div className="row justify-content-center">
                  <div className="col-12 col-md-10 text-left">
                    <p className="text-muted">
                      Are you sure that you want to delete
                      <span className="font-weight-medium text-text-dark">
                        {' '}
                        {assetToDelete?.nickname ?? 'this Asset'}
                      </span>
                      ?
                    </p>
                  </div>
                </div>
              );
          }
        })()}
        <div className="row col-12 col-md-10 text-right text-danger">
          {error}
        </div>
        <ModalFooter className="border-0">
          <button
            className="btn btn-danger py-0 px-4 mr-4"
            onClick={handleDeleteAsset}
          >
            {deleteRequestPending ? (
              <FontAwesomeIcon icon={faCircleNotch} size="lg" spin />
            ) : (
              'Yes, Delete Asset'
            )}
          </button>
          <button
            className="btn btn-outline-secondary py-0 px-4"
            onClick={() => toggleModal()}
          >
            Cancel
          </button>
        </ModalFooter>
      </ModalBody>
      <style jsx>{`
        .btn {
          font-size: 0.9rem;
        }
      `}</style>
    </Modal>
  );
}

DeleteAssetModalDisplay.propTypes = {
  assetToDelete: PropTypes.shape({
    assetAssociation: PropTypes.shape({
      subscription_status: PropTypes.string,
    }),
    orgID: PropTypes.string,
  }),
  deleteRequestPending: PropTypes.bool,
  handleDeleteAsset: PropTypes.func,
  error: PropTypes.string,
  isOpen: PropTypes.bool,
  toggleModal: PropTypes.func,
};
